import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { partnerNewsKeys } from '@/api/query-keys';
import {
  listPartnerNewsContract,
  type ListPartnerNewsResponse,
  type PartnerNews
} from '@bliks-io/contracts';

/** Published news for the partner home page, pinned first. */
export function usePartnerNews() {
  return useQuery({
    queryKey: partnerNewsKeys.partner(),
    queryFn: async ({ signal }): Promise<PartnerNews[]> => {
      const { data } = await apiClient.get<ListPartnerNewsResponse>(listPartnerNewsContract.path, {
        signal
      });
      return data.data;
    }
  });
}
